//https://vue-feather-icons.netlify.com/
//import * as icons from 'vue-feather-icons';
//import * as icons from '@zhuowenli/vue-feather-icons'

export default {
  name: "Icon",
  props: {
    spinning: Boolean,
    hidden: Boolean
  },
  data() {
    return {
      classes: {
        spinning: this.spinning,
        hidden: this.hidden
      }
    };
  },
  methods: {
    setHidden(isHidden) {
      this.classes.hidden = isHidden;
    }
  }
};